import { routes2 } from '@linqpal/models'

export const getPaymentPlans = async (invoice: any): Promise<any[] | null> => {
  try {
    const res = (await routes2.company.getPlansForIntegration(
      invoice?.company?.id,
      invoice?.total_amount,
      invoice?.customerId,
      invoice?.supplierInvitationDetails,
    )) as {
      data: any[]
    }
    return res.data
  } catch (err) {
    console.error(err)
    return null
  }
}
